import './App.css'
import './AppStyles.css'
import 'bootstrap/dist/css/bootstrap.min.css';

import { observer } from 'mobx-react-lite';
import React, { useEffect, useState } from 'react';
import { BrowserRouter } from 'react-router-dom';
import AppRouter from './components/AppRouter';
import { checkToken, logout } from './http/userAPI';
import Navbar from './components/Navbar/Navbar';
import useUser from './hooks/useUser';
import MyLoader from './components/UI/MyLoader/MyLoader';

const App: React.FC = observer(() => {
    const [loading, setLoading] = useState<boolean>(true);
    const userStore = useUser();
    
    useEffect(() => {
        const checkUserToken = async () => {
            const userData = await checkToken();
            if (userData) {
                userStore.setUser(userData);
            } else {
                logout(); 
            }
            setLoading(false);
        };
        checkUserToken();
    }, [userStore]);
    
    if (loading) {
        return (
            <div className='app_loadingContaainer'>
                <MyLoader />
            </div>
        )
    }
    
    return (
        <BrowserRouter>
            <div className='app_inner_container'>
                <div className='app_content_container'>
                    <Navbar />
                    <div className='app_inner_container_appRouter'>
                        <AppRouter />
                    </div>
                </div>
            </div>
        </BrowserRouter>
    )
});

export default App;